var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.questions),function(question,index){return _c('div',{staticClass:"question-pages"},[_c('Question',{attrs:{"answers":question.answers,"question-title":question.title,"question-sub-title":question.subTitle,"question-number":index,"user-answers":_vm.userAnswers},on:{"click":_vm.click}})],1)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0aee0435","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/QuestionPage.vue
// module id = null
// module chunks = 